import LeRequest from "le-request-copy";

const { post, get, post_formdata } = new LeRequest();

// 获取购物车数据
export async function getCartList() {
  return get(`/napi/cart/getcart.jhtm`);
}

// 购物车切换商品选中
export async function activeItem(data) {
  return post_formdata(`/napi/cart/activeItem.jhtm`, {
    data,
  });
}
// 购物车提交
export async function submitCart(data) {
  return post(`/napi/checkout/checkout.jhtm`, {
    data,
    postType: "formdata",
  });
}
